/* Geist V9 – megoldásoldal: feltétel-választó (szín / hőérzékeny), kiemelt lépés (?k4=), változatválasztó, „Mindet a kosárba”.
   Kosár: /cart/add.js több tétellel (sor-tulajdonság: _v9mo) → ha ≥ 3 tétel: /cart/update.js a meglévő kódok + SZETT5,
   attribútumok: _v8set (a v8-cart.js ezzel ellenőrzi, és leveszi a SZETT5-öt, ha a csomag megbomlik), _v9mo, _v9urlap.
   Mérés: Shopify.analytics.publish('geist_mindet_kosarba') + gtag, ha van. BUILD-01, 2026-10-14. */
(function () {
  var root = document.getElementById('v9mo');
  if (!root || root.dataset.init) return;
  root.dataset.init = '1';
  var ROOT = (window.Shopify && Shopify.routes) ? Shopify.routes.root : '/';
  var SET = 'SZETT5';
  var H = root.dataset.h;
  var qs = new URLSearchParams(location.search);
  var K4 = qs.get('k4') || '';
  var URLAP = qs.get('k') || (qs.get('k1') ? 'kereso' : '');
  var state = { szin: null, ho: 'igen' };
  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return [].slice.call((el || root).querySelectorAll(s)); };
  var fmt = function (c) { return String(Math.round(c / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' Ft'; };

  function track(name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', name, data); } catch (e) {}
  }

  /* ---- feltételek ---- */
  if (/^(fekete|kopott_fekete)$/.test(K4)) state.szin = 'fekete';
  else if (/^(mas|kopott_mas)$/.test(K4)) state.szin = 'mas';
  if (K4 === 'nem') state.ho = 'nem';
  $$('[data-v9-cond] input').forEach(function (i) {
    var g = i.name.replace('v9c-', '');
    if (state[g] === i.value) i.checked = true;
    i.addEventListener('change', function () { if (i.checked) { state[g] = i.value; applyCond(); } });
  });
  function active(el) {
    var g = el.dataset.g; if (!g) return true;
    return state[g] === el.dataset.v;
  }
  function applyCond() {
    $$('.v9-step[data-g]').forEach(function (li) {
      var g = li.dataset.g; li.classList.toggle('is-off', !!state[g] && state[g] !== li.dataset.v);
    });
    $$('.v9-list li[data-g]').forEach(function (li) {
      var g = li.dataset.g; li.classList.toggle('is-off', !!state[g] && state[g] !== li.dataset.v);
    });
    if (state.szin === 'fekete') preselect('Fekete');
    refresh();
  }

  /* ---- változatválasztó ---- */
  function resolve(box) {
    var vars = []; try { vars = JSON.parse(box.dataset.vars || '[]'); } catch (e) {}
    var want = {}; var ok = true;
    $$('[data-o]', box).forEach(function (el) {
      if (!el.value) { ok = false; if (el.tagName === 'SELECT') el.classList.add('is-need'); }
      else { want['o' + el.dataset.o] = el.value; if (el.tagName === 'SELECT') el.classList.remove('is-need'); }
    });
    if (!ok) return null;
    return vars.filter(function (v) { return Object.keys(want).every(function (k) { return v[k] === want[k]; }); })[0] || null;
  }
  function preselect(val) {
    $$('.v9-pc__sel select').forEach(function (s) {
      if (s.value) return;
      if ([].some.call(s.options, function (o) { return o.value === val; })) { s.value = val; s.dispatchEvent(new Event('change', { bubbles: true })); }
    });
  }
  root.addEventListener('change', function (e) {
    var sel = e.target.closest('.v9-pc__sel'); if (!sel) return;
    var v = resolve(sel);
    var card = sel.closest('[data-v9-card]'), szett = sel.closest('[data-v9-szett]');
    var host = card || szett; if (!host) return;
    if (v) { host.dataset.vid = v.id; host.dataset.price = v.p; host.dataset.av = v.a; }
    else { delete host.dataset.vid; }
    var pe = $('[data-v9-price]', host);
    if (pe && v) pe.textContent = fmt(v.p) + (v.a ? '' : ' – jelenleg nincs készleten');
    var add = card && $('[data-v9-add]', card); if (add) add.disabled = !(v && v.a);
    if (card) {
      var n = card.dataset.v9Card;
      $$('.v9-list li[data-sel][data-n="' + n + '"]').forEach(function (li) {
        if (v) {
          li.dataset.vid = v.id; li.dataset.price = v.p; li.dataset.av = v.a;
          var t = li.querySelector('span'); if (!li.dataset.base) li.dataset.base = t.textContent;
          t.textContent = li.dataset.base + ' – ' + [v.o1, v.o2].filter(Boolean).join(' / ');
        } else { delete li.dataset.vid; }
      });
    }
    refresh();
  });

  /* ---- összeg ---- */
  function rows() { return $$('.v9-list li').filter(function (li) { return active(li); }); }
  function refresh() {
    var sumEl = $('[data-v9-sum]'); if (!sumEl) return;
    var t = 0, n = 0, need = false;
    var cond = $$('.v9-list li[data-g]').some(function (li) { return !state[li.dataset.g]; });
    rows().forEach(function (li) {
      li.classList.toggle('is-need', !li.dataset.vid);
      if (!li.dataset.vid) { need = true; return; }
      var av = li.dataset.av === 'true';
      li.classList.toggle('is-na', !av);
      var b = li.querySelector('[data-v9-lp]'); if (b) b.textContent = av ? fmt(+li.dataset.price) : 'nincs készleten';
      if (av) { t += +li.dataset.price; n++; }
    });
    var old = $('[data-v9-sum-old]'), btn = $('[data-v9-all]');
    if (n >= 3 && !need && !cond) { old.hidden = false; old.textContent = fmt(t); sumEl.textContent = fmt(Math.round(t * 0.95)); btn.innerHTML = 'Mindet a kosárba <small>−5%</small>'; }
    else { old.hidden = true; sumEl.textContent = n ? fmt(t) : '–'; btn.textContent = 'Mindet a kosárba'; }
    var msg = $('[data-v9-msg]');
    if (cond) msg.textContent = 'Előbb válaszd ki fent, milyen a felület – ettől függ, melyik termék kell.';
    else if (need) msg.textContent = 'Válassz kiszerelést és színt a megjelölt lépésnél.';
    else msg.textContent = (n >= 3) ? 'A teljes csomagra −5% kedvezmény jár (SZETT5), amíg minden tétele a kosárban van.' : '';
    msg.classList.toggle('is-warn', cond || need);
  }

  /* ---- kosár ---- */
  function post(u, b) { return fetch(ROOT + u, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(b) }).then(function (r) { return r.json(); }); }
  async function add(items, btn, okText, full) {
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var secs = (cart && cart.getSectionsToRender) ? cart.getSectionsToRender().map(function (s) { return s.id; }) : null;
    var body = { items: items }; if (secs) { body.sections = secs; body.sections_url = location.pathname; }
    var old = btn.innerHTML; btn.disabled = true; btn.classList.add('is-busy');
    try {
      var j = await post('cart/add.js', body);
      if (j.status) { btn.innerHTML = old; btn.disabled = false; return { ok: false, msg: j.description || 'Valamelyik tétel most nem tehető kosárba.' }; }
      var cur = await fetch(ROOT + 'cart.js').then(function (r) { return r.json(); });
      var attrs = { _v9mo: H, _v9urlap: URLAP || 'kozvetlen' };
      var ub = { attributes: attrs };
      if (full) {
        var codes = (cur.discount_codes || []).map(function (d) { return d.code; }).filter(function (c) { return String(c).toUpperCase() !== SET; });
        codes.push(SET); ub.discount = codes.join(','); attrs._v8set = items.map(function (i) { return i.id; }).join(',');
      }
      if (secs) { ub.sections = secs; ub.sections_url = location.pathname; }
      j = await post('cart/update.js', ub);
      if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      if (cart && cart.renderContents && j.sections) cart.renderContents(j);
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'v9-mo', cartData: j });
      btn.textContent = okText; btn.classList.add('is-ok');
      setTimeout(function () { btn.disabled = false; btn.classList.remove('is-ok'); btn.innerHTML = old; refresh(); }, 2600);
      return { ok: true };
    } catch (err) { btn.innerHTML = old; btn.disabled = false; return { ok: false, msg: 'Hiba történt, próbáld újra.' }; }
    finally { btn.classList.remove('is-busy'); }
  }
  function line(id) { return { id: +id, quantity: 1, properties: { _v9mo: H } }; }

  var all = $('[data-v9-all]');
  if (all) all.addEventListener('click', async function () {
    var msg = $('[data-v9-msg]');
    var r = rows();
    var condMiss = $$('.v9-list li[data-g]').filter(function (li) { return !state[li.dataset.g]; })[0];
    if (condMiss) { var c = $('[data-v9-cond="' + condMiss.dataset.g + '"]'); if (c) { c.scrollIntoView({ behavior: 'smooth', block: 'center' }); c.querySelector('input').focus({ preventScroll: true }); } refresh(); return; }
    var miss = r.filter(function (li) { return !li.dataset.vid; })[0];
    if (miss) { var st = document.getElementById('lepes-' + miss.dataset.n); if (st) { st.scrollIntoView({ behavior: 'smooth', block: 'center' }); var s = st.querySelector('select:not([disabled])'); if (s) s.focus({ preventScroll: true }); } refresh(); return; }
    var items = r.filter(function (li) { return li.dataset.av === 'true'; }).map(function (li) { return line(li.dataset.vid); });
    if (!items.length) { msg.textContent = 'A tételek jelenleg nincsenek készleten.'; return; }
    var full = items.length >= 3;
    var sum = r.filter(function (li) { return li.dataset.av === 'true'; }).reduce(function (a, li) { return a + (+li.dataset.price); }, 0);
    var res = await add(items, all, full ? '✓ Kosárba téve, −5% a csomagra' : '✓ Kosárba téve', full);
    if (!res.ok) { msg.textContent = res.msg; msg.classList.add('is-warn'); return; }
    track('geist_mindet_kosarba', { eredmeny: H, tetelek: items.length, osszeg: Math.round(sum / 100), urlap: URLAP || 'kozvetlen' });
  });

  root.addEventListener('click', async function (e) {
    var b = e.target.closest('[data-v9-add]');
    if (b) {
      var card = root.querySelector('[data-v9-card="' + b.dataset.v9Add + '"]');
      if (!card || !card.dataset.vid) return;
      var r = await add([line(card.dataset.vid)], b, '✓ Kosárban', false);
      if (r.ok) track('geist_tetel_kosarba', { eredmeny: H, termek: card.dataset.h });
      return;
    }
    var sb = e.target.closest('[data-v9-szett-add]');
    if (sb) {
      var box = sb.closest('[data-v9-szett]'), m = $('[data-v9-szett-msg]');
      if (!box.dataset.vid) { m.textContent = 'Válassz színt a szetthez.'; m.classList.add('is-warn'); var s2 = box.querySelector('select'); if (s2) s2.focus(); return; }
      if (box.dataset.av !== 'true') { m.textContent = 'Ez a változat jelenleg nincs készleten.'; return; }
      var rr = await add([line(box.dataset.vid)], sb, '✓ A szett a kosárban', false);
      if (!rr.ok) { m.textContent = rr.msg; m.classList.add('is-warn'); }
      else track('geist_szett_kosarba', { eredmeny: H, urlap: URLAP || 'kozvetlen' });
    }
  });

  /* ---- újraindítás a kereső paramétereivel, kiemelés ---- */
  var rs = $('[data-v9-restart]');
  if (rs && qs.get('k1')) {
    var p = new URLSearchParams(); ['k1', 'k2'].forEach(function (k) { if (qs.get(k)) p.set(k, qs.get(k)); });
    rs.href = rs.href.split('?')[0] + '?' + p.toString() + '#kereso';
  }
  if (K4) {
    var hl = $$('.v9-step[data-kiemel]').filter(function (li) { return li.dataset.kiemel.split(',').indexOf(K4) > -1; });
    hl.forEach(function (li) { li.classList.add('is-hl'); });
    if (hl[0]) setTimeout(function () { hl[0].scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 400);
  }
  if (URLAP) track('geist_urlap_kesz_oldal', { urlap: URLAP, eredmeny: H });
  applyCond();
})();
